import React from "react";
import { useSelector } from "react-redux";
import clsx from "clsx";
import { SHAPE_THICKNESS } from "../../constants/Constants";
import { setMarkupLineThickness } from "./MarkupFunction";

const ThicknessButton = () => {
    const { selectedThicknessForShape } = useSelector((state) => state.markup);

    const shapThicknessHTML = SHAPE_THICKNESS.map((thickness) => (
        <li key={thickness}>
            <div className='dropdown-item-div'>
                <button
                    className={clsx("dropdown-item dropdown-item-thickness-btn", selectedThicknessForShape === thickness && "active")}
                    onClick={() => setMarkupLineThickness(thickness)}
                >
                    <span className={`thickness-icon thickness-${thickness}`}></span>
                    <span className='for-text'>{thickness}px</span>
                </button>
            </div>
        </li>
    ));

    return (
        <div className='markup-menu-item-in markup-thickness-box'>
            <div className='markup-common-dropdown markup-thickness-dropdown dropdown'>
                <button
                    className='btn dropdown-toggle triangle-none thickness-dropdown-toggle'
                    type='button'
                    id='markup-thickness-dropdown'
                    data-bs-toggle='dropdown'
                    aria-expanded='false'
                >
                    <span className={`thickness-icon thickness-${selectedThicknessForShape}`}></span>
                    <span className='for-text'>{selectedThicknessForShape}px</span>
                    <span className='for-triangle icon-down-triangle'></span>
                </button>
                <div className='dropdown-menu markup-common-dropdown-menu' aria-labelledby='markup-thickness-dropdown'>
                    <div className='dropdown-menu-in'>
                        <ul className='dropdown-scroll custom-scroll-thin'>{shapThicknessHTML}</ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ThicknessButton;
